import { client } from "helper/apolloConfig";
import {
  generateNoOfEntries,
  generatePassRate,
  generateTitlesReport,
  generateTrailDrawReport,
  generateTrialStatistics,
  generateTrialResultsPremium,
  generateTrialResults,
  generatedDogResults,
  dogResultReport5,
  getPotentialTitlesQuery,
  generateAllCompetitorsQuery,
} from "redux/features/reports/reportsGql";

export const DonwloadNoOfEntries = async (trialCalenderId) => {
  const result = await client.query({
    query: generateNoOfEntries,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.generateReportSitNaePremier;
  return data?.downloadUrl;
};

export const DonwloadPassRate = async (trialCalenderId) => {
  const result = await client.query({
    query: generatePassRate,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.generatePassRateReport;
  return data?.downloadUrl;
};

export const DownloadTitlesReport = async (trialCalenderId) => {
  const result = await client.query({
    query: generateTitlesReport,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.generateAllCompetitorsReportTitle;
  window.open(data?.downloadUrl, "_blank");
  return data;
};

export const DownloadTrialDrawReport = async (trialCalenderId) => {
  const result = await client.query({
    query: generateTrailDrawReport,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.generateAllCompetitorsReport;
  return data?.downloadUrl;
};

export const DonwloadTrialStatistics = async (trialCalenderId) => {
  const result = await client.query({
    query: generateTrialStatistics,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.dogResultReport4;
  return data;
};

export const DonwloadTrialPremium = async (trialCalenderId) => {
  const result = await client.query({
    query: generateTrialResultsPremium,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.dogResultReport2;
  return data;
};

export const DonwloadTrialResults = async (trialCalenderId) => {
  const result = await client.query({
    query: generateTrialResults,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.dogResultReport3;
  return data;
};

export const DonwloadDogResults = async (trialCalenderId) => {
  const result = await client.query({
    query: generatedDogResults,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.dogResultReport1;
  return data;
};

export const DonwloadDogResultsPremier = async (trialCalenderId) => {
  const result = await client.query({
    query: dogResultReport5,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.dogResultReport5;
  return data;
};

export const DonwloadPotentialTitles = async (trialCalenderId) => {
  const result = await client.query({
    query: getPotentialTitlesQuery,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.getPotentialTitlesReport;
  return data;
};

export const DonwloadAllCompetitors = async (trialCalenderId) => {
  const result = await client.query({
    query: generateAllCompetitorsQuery,
    variables: {
      trialCalendarId: +trialCalenderId,
    },
    fetchPolicy: "no-cache",
  });
  const data = result?.data?.generateAllCompetitorsReport;
  return data?.downloadUrl;
};